import remark from 'remark'
import html from 'remark-html'
import remarkAttr from 'remark-attr'
import bracketedSpans from 'remark-bracketed-spans'
import breaks from 'remark-breaks'

export default function markdown(md, enableBrackets = true) {
    let parsed = {
        __html: '',
    }

    const parser = remark()
        .use(html)
        .use(breaks)
        .use(remarkAttr)

    if (enableBrackets) {
        parser.use(bracketedSpans)
    }

    parser.process(md, (err, file) => {
        parsed = {
            __html: String(file),
        }
    })

    return parsed
}
